// Constants to be used when forwarding Amplitude analytics to Swift

export const SEND_AMPLITUDE_EVENT = 'SEND_AMPLITUDE_EVENT';
export const SET_AMPLITUDE_USER_PROPERTIES = 'SET_AMPLITUDE_USER_PROPERTIES';
export const SET_AMPLITUDE_USER = 'SET_AMPLITUDE_USER';
export const INITIALISE_AMPLITUDE = 'INITIALISE_AMPLITUDE';
